<template>
  <div>
    <div>
      <ul class="settings-menu">
        <li>
          <a href="#" @click.prevent="showLogoImgModal">Logo image source</a>
        </li>
        <li>
          <a href="#" @click.prevent="showRemoveDataModal">Remove data</a>
        </li>
        <li v-if="$can('all', 'Admin')">
          <a href="#">
            <b-form-checkbox
              v-model="isTemplate"
              @change="isTemplateChanged"
              class="settings-menu__checkbox"
            >
              Is template
            </b-form-checkbox>
          </a>
        </li>
        <li v-if="$can('all', 'Admin') && isTemplate">
          <a href="#" @click.prevent="$refs.templateInfoModal.open()">Set template info</a>
        </li>
        <li>
          <a href="#" @click.prevent="showSlackTeamModal">Slack Team</a>
        </li>
        <li>
          <a href="#" @click.prevent="showTabsConfigModal">Pages Configuration</a>
        </li>
        <li>
          <a href="#" @click.prevent="showRegionalSettingsModal">Regional Settings</a>
        </li>
        <li>
          <a href="#" @click.prevent="showLogsModal">Show Data Logs</a>
        </li>
        <li>
          <a href="#" @click.prevent="showSchemaModal">Schema Builder</a>
        </li>
        <li>
          <a href="#" v-if="$can('manageUsers', 'Dashboard_' + currentDash) || $can('all', 'Admin')" @click.prevent="showDashboardACModal">Dashboard Access</a>
        </li>
      </ul>
    </div>
    <LogoImgModal :settings="settings" :eventBus="eventBus" />
    <RemoveDataModal :eventBus="eventBus" />
    <SlackTeamModal :eventBus="eventBus" />
    <ShowLogsModal :eventBus="eventBus" />
    <showSchemaModal :eventBus="eventBus" />


    <TabsConfigModal ref="tabsConfigModal" />
    <RegionalSettingsModal ref="regionalSettingsModal" />
    <TemplateInfoModal ref="templateInfoModal" />

    <treeselect
      :multiple="true"
      :options="dashObjects"
      placeholder="Select the grids and pages to export"
      v-model="selectedObjects"
      :flat="true"
      :default-expand-level="1"
    />

    <div class="export-buttons">
      <b-button @click="$exportApp">Download Backup</b-button>
      <b-button @click="$exportModel">Export Model</b-button>
      <b-button @click="$importModel">Import App</b-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
// services
import db from '@/services/db'
// components
import LogoImgModal from './Modals/LogoImg'
import RemoveDataModal from './Modals/RemoveData'
import SlackTeamModal from './Modals/SlackTeamModal'
import TabsConfigModal from './Modals/TabsConfig'
import RegionalSettingsModal from './Modals/RegionalSettings'
import JsonPorter from 'json-porter'
import ShowLogsModal from './Modals/ShowLogsModal'
import TemplateInfoModal from './Modals/TemplateInfo'
import ShowSchemaModal from './Modals/BuildSchema'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  components: {
    LogoImgModal,
    RemoveDataModal,
    SlackTeamModal,
    TabsConfigModal,
    RegionalSettingsModal,
    ShowLogsModal,
    TemplateInfoModal,
    ShowSchemaModal
  },
  data() {
    return {
      settings: null,
      eventBus: new Vue(),
      selectedObjects: [],
      tabs: {},
      subTabs: {},
      widgets: {},
      isTemplate: false,
    }
  },
  computed: {
    ...mapState(['currentDash', 'dataGrid_options', 'userId']),
    dashObjects() {
      //get the tabs

      var options = []
      var grids = { id: 'grids', label: 'Grids', children: [] }

      for (let dataGridKey in this.dataGrid_options) {
        const dataGrid = this.dataGrid_options[dataGridKey]

        grids.children.push({
          id: '$grid.' + dataGridKey,
          label: dataGrid.title,
        })
      }
      options.push(grids)

      var tabs = { id: 'tabs', label: 'Tabs', children: [] }
      for (let key in this.tabs) {
        const tab = this.tabs[key]
        tabs.children.push({ id: '$tab.' + key, label: tab.title })
      }
      options.push(tabs)

      var subTabs = { id: 'subTabs', label: 'Sub Pages', children: [] }
      for (let key in this.subTabs) {
        if (!this.tabs[key]) {
          console.error(`[SubPage] - parent tab "${key}" is missing`)
          continue
        }

        const subTab = this.subTabs[key]

        for (let skey in subTab) {
          const sTab = subTab[skey]
          subTabs.children.push({
            id: '$subTab.' + skey + '.' + key,
            label: this.tabs[key].title + '>' + sTab.title,
          })
        }
      }
      options.push(subTabs)

      return options
    },
  },
  methods: {
    async $importModel() {
      var jp = new JsonPorter()
      let importObject = await jp.import()
      var updateRef = await db.getRef('')
      updateRef.update(importObject)
    },
    async $exportApp() {
      const dashboard = await db.dashboards.readOne(this.currentDash)
      new JsonPorter().export(dashboard, 'Tangle Dashboard Export.json')
      // let data = {}
      // db.dashboards.read(this.userId, dashboards => {
      //   Object.keys(dashboards).map(async dashboard => {
      //     data[dashboard] = await db.dashboards.readOne(dashboard)
      //     if (Object.keys(data).length === Object.keys(dashboards).length) {
      //       new JsonPorter().export(data, 'Tangle Dashboards Export.json')
      //     }
      //   })
      // })
    },
    $exportModel() {
      var jp = new JsonPorter()
      var _this = this
      var fullExport = {}
      var gridsExport = {}
      var tabsExport = {}
      var tabsArray = []
      var subTabsArray = []
      var widgetsExport = {}

      this.selectedObjects.forEach(function(item) {
        var type = item.split('.')[0]
        var ref = item.split('.')[1]
        var parent = item.split('.')[2]

        if (type == '$grid')
          fullExport['widgetsData/dataGrid/' + ref] =
            _this.dataGrid_options[ref]

        if (type == '$tab') {
          fullExport['tabs/' + ref] = _this.tabs[ref]
          tabsArray.push(ref)
        }
        if (type == '$subTab') {
          fullExport['subTabs/' + parent + '/' + ref] =
            _this.subTabs[parent][ref]
          subTabsArray.push(ref)
        }
      })

      for (let key in this.widgets) {
        const widget = this.widgets[key]

        if (tabsArray.includes(widget.tab))
          fullExport['widgets/' + key] = widget
        if (subTabsArray.includes(widget.subTab))
          fullExport['widgets/' + key] = widget
      }

      jp.export(fullExport, 'Tangle Model Export.json')
    },
    showLogoImgModal() {
      this.eventBus.$emit('showLogoImgModal')
    },
    showRemoveDataModal() {
      this.eventBus.$emit('showRemoveDataModal')
    },
    showWorkflowItems() {
      this.$store.commit('setActiveToolbarItem', 3)
    },
    showSlackTeamModal() {
      this.eventBus.$emit('showSlackTeamModal')
    },
    showLogsModal() {
      this.eventBus.$emit('showLogsModal')
    },
    showSchemaModal() {
      this.eventBus.$emit('showSchemaModal')
    },
    showTabsConfigModal() {
      this.$refs.tabsConfigModal.open()
    },
    showRegionalSettingsModal() {
      this.$refs.regionalSettingsModal.open()
    },
    isTemplateChanged() {
      if (!confirm('Are you sure?')) {
        this.$nextTick(() => {
          this.isTemplate = !this.isTemplate
        })
        return
      }

      this.$nextTick(() => {
        if (this.isTemplate) {
          db.dashboards.setAsTemplate(this.currentDash)
        } else {
          db.dashboards.removeFromTemplateList(this.currentDash)
        }
      })
    },
    showDashboardACModal() {
      eventBus.$emit('showDashboardACModal')
    }
  },
  async created() {
    db.settings.read(this.currentDash, settings => {
      this.settings = settings
    })
    db.dashboards.getTemplateDashboardsList()
      .then(templates => {
        if (templates.includes(this.currentDash)) this.isTemplate = true
      })

    var search = 'a'
    var results = await db
      .getRef('workflow')
      .orderByChild('name')
      //.startAt('%ef')
      .endAt('ef\uf8ff')
      .once('value')
    var rdata = results.val()
    console.log('get workflows', rdata)

    var tabs = await db
      .getRef('')
      .child('tabs')
      .once('value')
    this.tabs = tabs.val()

    var subTabs = await db
      .getRef('')
      .child('subTabs')
      .once('value')
    this.subTabs = subTabs.val()

    var widgets = await db
      .getRef('')
      .child('widgets')
      .once('value')
    this.widgets = widgets.val()
  },
}
</script>

<style lang="scss">
.settings-menu {
  &__checkbox {
    label {
      font-size: 16px !important;
    }
  }
}
.export-buttons button {
  margin-bottom: 5px;
  margin-top: 5px;
}
</style>
